import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

export const LegacyNextWrapper = () => {
    const { useLegacyNext } = useFlags();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const isOnNextPage = location?.pathname.includes("/next");

        if (useLegacyNext && !isOnNextPage) {
            navigate("/next");
        } else if (!useLegacyNext && isOnNextPage) {
            navigate("/");
        }
    }, [useLegacyNext, navigate, location?.pathname]);

    return <Outlet />;
};
